<template>
  <v-expansion-panels class="filters-menu">
    <v-expansion-panel>
      <v-expansion-panel-header>{{ $t("filters") }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-autocomplete
          v-model="owner"
          :items="owners"
          :label="$t('filters-owner')"
          clearable
          outlined
        >
        </v-autocomplete>
        {{ $t("filters-processed-seeds") }}
        <v-checkbox
          v-model="sunflowerSeeds"
          :label="$t('filters-sunflower')"
          class=""
        ></v-checkbox>
        <v-checkbox
          v-model="rapeSeeds"
          :label="$t('filters-rape')"
          class="mt-0"
        ></v-checkbox>
        <v-checkbox
          v-model="soyBean"
          :label="$t('filters-soybean')"
          class="mt-0"
        ></v-checkbox>

        <v-divider></v-divider>

        <v-checkbox
          v-model="refining"
          :label="$t('filters-refining')"
        ></v-checkbox>
        <v-checkbox
          v-model="esterifying"
          :label="$t('filters-esterifying')"
          class="mt-0"
        ></v-checkbox>

        <v-select
          v-model="extractPress"
          :items="extractPressOptions"
          :label="$t('filters-extract-press')"
          clearable
          outlined
        ></v-select>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "Filters",

  data() {
    return {
      expand: false,
      extractPressOptions: [
        { text: this.$t("filters-extract"), value: "E" },
        { text: this.$t("filters-press"), value: "P" }
      ]
    };
  },

  computed: {
    owners() {
      return this.$store.getters["sites/owners"];
    },
    owner: {
      get() {
        return this.$store.getters["filters/owner"];
      },
      set(value) {
        if (value === undefined) {
          value = null;
        }
        this.$store.commit("filters/setOwner", value);
      }
    },
    sunflowerSeeds: {
      get() {
        return this.$store.getters["filters/sunflowerSeeds"];
      },
      set(value) {
        this.$store.commit("filters/setSunflowerSeeds", value);
      }
    },
    rapeSeeds: {
      get() {
        return this.$store.getters["filters/rapeSeeds"];
      },
      set(value) {
        this.$store.commit("filters/setRapeSeeds", value);
      }
    },
    soyBean: {
      get() {
        return this.$store.getters["filters/soyBean"];
      },
      set(value) {
        this.$store.commit("filters/setSoyBean", value);
      }
    },
    refining: {
      get() {
        return this.$store.getters["filters/refining"];
      },
      set(value) {
        this.$store.commit("filters/setRefining", value);
      }
    },
    esterifying: {
      get() {
        return this.$store.getters["filters/esterifying"];
      },
      set(value) {
        this.$store.commit("filters/setEsterifying", value);
      }
    },
    extractPress: {
      get() {
        return this.$store.getters["filters/extractPress"];
      },
      set(value) {
        if (value === undefined) {
          value = null;
        }
        this.$store.commit("filters/setExtractPress", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.filters-menu {
  position: absolute;
  top: 10px;
  left: 10px;
  width: calc(100% - 100px);
  max-width: 400px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-right: -80px;

    .v-expansion-panel {
      &::before {
        box-shadow: none;
      }
    }

    .v-expansion-panel-header {
      position: relative;
      z-index: 1;
      border-radius: $border-radius-root;
      @include elevation(2);

      &.v-expansion-panel-header--active {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }

    .v-expansion-panel-content {
      position: relative;
      z-index: 2;
      padding-top: 16px;
      background-color: white;
      margin-right: -80px;
      border-radius: $border-radius-root;
      border-top-left-radius: 0px;
      box-shadow: map-get($shadow-key-umbra, 3),
        map-get($shadow-key-penumbra, 3), map-get($shadow-key-ambient, 0);
    }
  }
}
</style>
